import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export function useSelectedProperty(defaultSelectedPropertyId?: string) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { push } = useRouter();

  const selectedPropertyId = searchParams.get('property') ?? defaultSelectedPropertyId ?? null;
  const setSelectedPropertyId = (id: string | null) => {
    if (id === null) {
      window.history.pushState(null, '', pathname);
      return;
    }
    const query = new URLSearchParams({ property: id });
    window.history.pushState(null, '', pathname + '?' + query.toString());
  };

  return {
    selectedPropertyId,
    setSelectedPropertyId,
  };
}
